import moment from "moment-timezone";

// Notes are stored in UTC. Accept the older Flask RFC response as well as
// Laravel SQL timestamps and the explicit ISO response; never guess a date.
const parseNoteDate = value => {
  if (typeof value !== "string" || !value.trim()) return null;
  const text = value.trim();
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(text);
  // Reject incomplete dates instead of inventing a day or year.
  const timestamp = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/.test(text);
  const parsed = moment.utc(text, dateOnly ? "YYYY-MM-DD" : timestamp ? moment.ISO_8601 : moment.RFC_2822, true);
  return parsed.isValid() ? { parsed, dateOnly } : null;
};

export const clientNoteDate = (note, salonTimezone) => {
  const date = parseNoteDate(note?.datetime) || parseNoteDate(note?.created_at);
  if (!date) return "";
  const timezone = typeof salonTimezone === "string" && moment.tz.zone(salonTimezone)
    ? salonTimezone : "UTC";
  // A historical date-only value has no time/offset to convert.
  return (date.dateOnly ? date.parsed : date.parsed.tz(timezone)).format("DD-MM-YYYY");
};

// Keep the author-selected/original date separate from the last edit instant.
export const clientNoteEditedDate = (note, salonTimezone) => {
  const date = parseNoteDate(note?.updated_at);
  if (!date) return "";
  if (date.dateOnly) return date.parsed.format("DD-MM-YYYY");
  const timezone = typeof salonTimezone === "string" && moment.tz.zone(salonTimezone)
    ? salonTimezone : "UTC";
  return date.parsed.tz(timezone).format("DD-MM-YYYY h:mm A z");
};
